import React, { useEffect, useState } from "react";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import {
  faCloud,
  faCloudRain,
  faRainbow,
  faSmog,
  faSnowflake,
  faSun,
  faWind,
} from "@fortawesome/free-solid-svg-icons";

const Display = ({ weatherInfo }) => {
  const [moodOfWeather, setMoodOfWheather] = useState(faCloud);

  const {
    humidity,
    pressure,
    temp,
    cityName,
    visibility,
    dt,
    weahterMood,
    country,
    speed,
  } = weatherInfo;

  useEffect(() => {
    if (weahterMood) {
      switch (weahterMood) {
        case "Sunny":
          setMoodOfWheather(faSun);
          break;
        case "Rain":
          setMoodOfWheather(faCloudRain);
          break;
        case "Extream":
          setMoodOfWheather();
          break;
        case "Snow":
          setMoodOfWheather(faSnowflake);
          break;
        case "sunshine":
          setMoodOfWheather(faCloudRain);
          break;
        case "Partially_cloudy":
          setMoodOfWheather(faCloud);
          break;
        case "Windy":
          setMoodOfWheather(faWind);
          break;
        case "Foggy":
          setMoodOfWheather(faSmog);
          break;
        case "Haze":
          setMoodOfWheather(faSun);
          break;
        default:
          setMoodOfWheather(faCloud);
      }
    }
  }, [weahterMood]);

  const sec = dt;
  const date = new Date(sec * 1000);
  const time = `${date.getHours()}:${date.getMinutes()}`;
  const currDate = `${date.getUTCDate()}/${
    date.getUTCMonth() + 1
  }/${date.getFullYear()}`;
  return (
    <>
      <div className="container">
        <div className="weatherImg">
          <FontAwesomeIcon icon={moodOfWeather} className="icon" />
        </div>
        <div className="temp">
          <div className="mainTemp">
            <h1>{temp} °C</h1>
            <h3>{weahterMood}</h3>
          </div>
          <div className="secTemp">
            <div className="city">{`${cityName}, ${country}`}</div>
            <p>{time}</p>
            <p>{currDate}</p>
          </div>
        </div>
        <div className="footer">
          <div>
            Wind <span>{`${speed} kmph`}</span>
          </div>
          <div>
            Humidity <span>{`${humidity} %`}</span>
          </div>
          <div>
            Pressure <span>{pressure}</span>
          </div>
          <div>
            Visibility <span>{visibility}</span>
          </div>
        </div>
      </div>
    </>
  );
};

export default Display;
